import type { GetSidebarTreeResponse } from "@workith/shared";
import { useCallback, useEffect, useRef, useState } from "react";
import api from "../../lib/api";

export function useSidebarTree(selectedFolderId: string | null) {
  const [data, setData] = useState<GetSidebarTreeResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const requestIdRef = useRef(0);

  const refresh = useCallback(async () => {
    const requestId = requestIdRef.current + 1;
    requestIdRef.current = requestId;
    setLoading(true);

    try {
      const params = new URLSearchParams();
      if (selectedFolderId) {
        params.set("selectedFolderId", selectedFolderId);
      }

      const response = await api.get<GetSidebarTreeResponse>(
        `/api/sidebar/tree${params.toString() ? `?${params.toString()}` : ""}`
      );
      if (requestIdRef.current === requestId) {
        setData(response);
      }
    } catch (fetchError) {
      if (requestIdRef.current === requestId) {
        console.error("Failed to fetch sidebar tree", fetchError);
      }
    } finally {
      if (requestIdRef.current === requestId) {
        setLoading(false);
      }
    }
  }, [selectedFolderId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { data, loading, refresh };
}
